import Header from "../home/header";
import { useLocation, useNavigate } from 'react-router-dom';
import Login from "../home/login_form";
import { useEffect, useState } from "react";
import UTILS from '../../utils/commons';
import { ApiClient } from "../../utils/api-client";
import CustomerItem from './customer_item'
import PaginationControl from "../home/pagination_control";
import Loading from "../home/Loading";
import { AxiosError } from "axios";

const Customers = ( props ) => {
    let navigate = useNavigate();
    var location = useLocation();
    var storedData = location.state || {};
    var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

    const [ customers, setCustomers ] = useState( [] );
    const [ filteredCustomers, setFilteredCustomers ] = useState( [] );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );
    const [ feedback, setFeedback ] = useState( "" );
    const [ loading, setLoading ] = useState( false );
    const [ searchTerm, setSearchTerm ] = useState( "" );
    const canManageCustomers = loginState?.role === UTILS.SALES || loginState?.role === UTILS.ADMIN;


    const getCustomers = async ( page = currentPage, size = pageSize ) => {
        setLoading( true )
        const endpoint = loginState.role === UTILS.SALES ? `customers/profile/${loginState.profile.id}` : 'customers';
        try {
            const response = await apiClient.get( endpoint, {
                params: {
                    page,
                    limit: size
                }
            } );
            const data = await response.data;
            setCustomers( data.data );
            setFilteredCustomers( data.data || [] );
            setCurrentPage( data.page );
            setTotalPages( Math.ceil( data.total / size ) );
            setHasNextPage( data.hasNextPage );
            setHasPreviousPage( data.hasPreviousPage );
            setLoading( false )
        } catch ( error ) {
            console.error( "Error fetching customers:", error );
            setLoading( false )
            if ( error instanceof AxiosError && error.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, state: { target: '/customers' } } );
            }
        }
    }
    const handlePageChange = ( newPage ) => {
        setCurrentPage( newPage );
        getCustomers( newPage, pageSize );
    }
    const handlePageSizeChange = ( newPageSize ) => {
        setPageSize( newPageSize );
        setCurrentPage( 1 );
        getCustomers( 1, newPageSize );
    }
    useEffect( () => {
        getCustomers();
    }, [] );

    useEffect( () => {
        const keyword = searchTerm.trim().toLowerCase();
        if ( !keyword ) {
            setFilteredCustomers( customers );
            return;
        }
        const filteredResults = customers.filter( p => {
            const name = ( p?.name || '' ).toLowerCase();
            const phone = ( p?.phone || '' ).toLowerCase();
            const region = ( p?.region || '' ).toLowerCase();
            return name.includes( keyword ) || phone.includes( keyword ) || region.includes( keyword );
        } );
        setFilteredCustomers( filteredResults );
    }, [ searchTerm, customers ] );

    const confirmDelete = ( itemId ) => {
        let message = "Are you sure you want to delete this customer?";
        if ( window.confirm( message ) ) {

            deleteCustomer( itemId ).then( result => {
                if ( parseInt( result.code ) === 0 ) {
                    storedData.customers = result.customers;
                    setCustomers( storedData.customers.filter( p => parseInt( p.status ) === 0 ) );
                }
                else setFeedback( result.msg );

            } ).catch( e => {
                console.log( "error: ", e );
                setFeedback( "Oops! Something went wrong" );
            } )
        }

    }
    const deleteCustomer = async ( pid ) => {

        const req = await apiClient.delete( `customers/${pid}` );
        if ( req.status === 200 ) {
            return "Customer successfully deleted"
        }
        else {
            return { code: -1, msg: "Failed to delete customer" };
        }
    }

    return ( <>
        <Header auth={loginState} />
        <section className="flex justify-start items-start">
            <div className="container">
                {feedback.length > 0 ? <div className="w-full md:w-10/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="feedback">{feedback}</div> : null}

                <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500">Directory</p>
                            <p className="text-2xl font-semibold text-gray-800">Customers</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                            <input
                                className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300"
                                type="text"
                                placeholder="Search by name, phone, or region..."
                                value={searchTerm}
                                onChange={( e ) => setSearchTerm( e.target.value )}
                            />
                            {canManageCustomers ? <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/customers/new", { replace: false } )}>Add Customer</button> : null}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
                        <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                            <p className="text-xs uppercase tracking-wide text-gray-500">Visible Customers</p>
                            <p className="text-lg font-semibold text-gray-800 mt-1">{UTILS.thousandSeparator( filteredCustomers.length )}</p>
                        </div>
                        <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                            <p className="text-xs uppercase tracking-wide text-gray-500">Current Page</p>
                            <p className="text-lg font-semibold text-gray-800 mt-1">{currentPage}</p>
                        </div>
                        <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
                            <p className="text-xs uppercase tracking-wide text-gray-500">Total Pages</p>
                            <p className="text-lg font-semibold text-gray-800 mt-1">{totalPages}</p>
                        </div>
                    </div>
                </div>
                {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                    <div className="mt-8">
                        {filteredCustomers.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                        <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap mt-4" id="list_container">
                            <div className="grid md:grid-cols-5 bg-gray-100 p-3 text-xs uppercase tracking-wide font-semibold text-gray-600">
                                <span>Name</span>
                                <span>Contact</span>
                                <span>Address</span>
                                <span>Region</span>
                                <span className="text-center">Actions</span>
                            </div>
                            {filteredCustomers && filteredCustomers.length > 0 ? filteredCustomers.map( ( r, i ) => {
                                return <CustomerItem data={r} key={r.id} canEdit={canManageCustomers} onDelete={() => confirmDelete( r.id )} onClick={() => { navigate( "/customers/view/" + r.id, { replace: false, state: r } ) }} onEdit={() => { navigate( "/customers/edit/" + r.id, { replace: false, state: r } ) }} className={i % 2 === 1 ? "bg-gray-100" : ""} />
                            } ) : <span className="text-center w-full py-8 px-4 text-gray-500">No customers found.</span>
                            }
                        </div>
                    </div>
                )}</div>
        </section>
    </> )

}
export default Customers;
